import * as eventbus from 'eventbusjs';

class EventService {

    debug = false;

    // fire event
    dispatch(name, data?) {
        if (this.debug)
            console.log('EVENT:', name, data);

        eventbus.dispatch(name, data);
    }

    // Subscribe one or more events to the same callback method.
    subscribe(event: string | Array<string>, cb) {
        if (Array.isArray(event)) {
            event.forEach(e => eventbus.addEventListener(e, cb));
        } else {
            eventbus.addEventListener(event, cb);
        }
    }

    unsubscribe(event: string | Array<string>, cb) {
        if (Array.isArray(event)) {
            event.forEach(e => eventbus.removeEventListener(e, cb));
        } else {
            eventbus.removeEventListener(event, cb);
        }
    }

}

export default new EventService();
